import {ROUTER_DATA_LOAD_FULFILLED} from '../router/router-actions';

export const initialState = () => ({
    isPending: false,
    data: {
        currencyCode: 'USD',
    },
    error: null,
});

export default function dynamicRates(state = initialState(), {type, payload}) {
    if (type === ROUTER_DATA_LOAD_FULFILLED) {
        return {
            ...state,
            ...payload.dynamicRates,
        };
    }

    return state;
}
